import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { LoginService } from 'src/app/Services/login.service';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class LoggedInGuard implements CanActivate {

    constructor(private loginService: LoginService, private rota: Router, private toastr: ToastrService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        if (this.loginService.estaLogado()) {
            return true;
        }

        this.rota.navigate(['publico']).then(() => this.toastr.warning('Você precisa fazer o login para acessar essa página.'));
        return false;
    }
}